<template>
    <div class="addclient row justify-content-md-center">
    <div class="col-md-4 col-md-offset-4">
    <div class="card">
      <div class="card-header">
        Správa telefonních čísel klienta
      </div>
      <div class="card-block">
            <div class="row justify-content-center" v-if="phoneNumbers.length > 0">
                <div class="col-md-12">
                </div>
                <div class="col-md-12">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Telefonní číslo</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="phoneNum in phoneNumbers" class="card-text">
                            <tr>
                                <td class="align-middle">
                                    {{ phoneNum.number }}
                                </td>
                                <td>
                                    {{ phoneNum.default === true ? 'výchozí' : '' }}
                                </td>
                                <td>
                                    {{ phoneNum.note }}
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row justify-content-center">
              <form v-if="!waitForData" @submit.prevent="submitForm">
              <div class="form-group col-md-12">
                  <div class="input-group">
                      <span class="input-group-addon">{{ selectedPhoneNumberPrefix }}</span>
                      <input v-model="selectedPhoneNumber" type="number" placeholder="telefonní číslo" class="form-control" id="phoneNumber">
                      <span class="input-group-addon">
                          Výchozí:&nbsp;
                        <input v-model="phoneNumber.default" type="checkbox" aria-label="Checkbox for following text input">
                      </span>
                      <input v-model="phoneNumber.note" type="text" class="form-control" id="phoneNumberf" placeholder="poznámka">
                      <button v-if="phoneNumberPending === false" type="submit" class="btn btn-primary">Přidat telefon</button>
                      <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                  </div>
                  <small id="numberError" class="form-text text-danger" v-if="phoneNumberError.number">{{ phoneNumberError.number.message }}</small>

                  <!--<input type="text" class="form-control"  >-->
              </div>
              <div class="form-group col-md-12">

              </div>
              </form>
            </div>

        <div  v-if="waitForData" class="row justify-content-around">
          <div class="">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        // email address
        emailAddressError: {},
        emailAddressPending: false,
        emailAddress: {
          email: ''
        },
        // phone number
        phoneNumberError: {},
        phoneNumberPending: false,
        phoneNumber: {
          number: '',
          default: true,
          note: ''
        },
        selectedPhoneNumberPrefix: '+420',
        selectedPhoneNumber: '',
        // phone numbers
        phoneNumbers: [],
        phoneNumbersError: {},
        // others
        setting: require('../../variables.js'),
        waitForResponse: false,
        waitForData: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: []
      }
    },
    methods: {
      submitForm () {
        this.postPhoneNumber()
        /* if (!this.clientCreated) {
         } else {
          this.putClient()
          if (!this.addressCreated) {
            this.postAddress()
          } else {
            this.putAddress()
          }
        } */
      },
      getCountries () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'country').then(response => {
          this.countries = response.data
          // this.useGovData = true
          this.waitForData = false
        }, response => {
          this.waitForData = false
        })
      },
      postPhoneNumber () {
        this.phoneNumberPending = true
        this.phoneNumber.number = this.selectedPhoneNumberPrefix + this.selectedPhoneNumber
        this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number', this.phoneNumber, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.phoneNumberPending = false
          this.getPhoneNumbers()
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.phoneNumberError = error.response.data.errors
          this.phoneNumberPending = false
        })
      },
      getPhoneNumbers () {
        // this.phoneNumberPending = true
        // this.phoneNumber.number = this.selectedPhoneNumberPrefix + this.selectedPhoneNumber
        this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid + '/phone_number').then(response => {
          this.phoneNumbers = response.data
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.phoneNumbersError = error.response.data.errors
          // this.phoneNumberPending = false
        })
      }
    },
    beforeMount () {
      this.getPhoneNumbers()
      // this.getCitizenship()
      // this.getCountries()
    },
    watch: {
      //
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.icon-male {
  color: dodgerblue;
  font-weight: bold;
}

.icon-female {
  color: deeppink;
  font-weight: bold;
}

.icon-genderless {
  color: #ccc;
  font-weight: bold;
}

.table > tbody > tr > td, .table > tfoot > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > td, .table > tfoot > tr > td {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/views/Client/AddContact.vue?5bff7ca7